import React from "react";
import { useNavigate } from "react-router-dom";

const Appointment = ({ appointmentActiveTab, appointments, consumerId }) => {
  const navigate = useNavigate();

  return (
    <div className="rounded-xl border border-1 overflow-hidden">
      <div className="max-h-[500px] overflow-y-auto">
        {/* Fixed height with scroll */}
        <table className="w-full min-w-[800px] border-collapse">
          <thead className="bg-gray-50 sticky top-0 z-10">
            <tr>
              <th className="py-3 px-4 text-left text-sm font-semibold text-[#60646C]">
                No.
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-[#60646C]">
                Provider Name
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-[#60646C]">
                Patient Name
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-[#60646C]">
                Date
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-[#60646C]">
                Time Slot
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-[#60646C]">
                Appointment Fee
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-[#60646C]">
                License/Registration No
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-[#60646C]">
                Appointment Status
              </th>
              <th className="py-3 px-4 text-left text-sm font-semibold text-[#60646C]">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {appointments?.length > 0 ? (
              appointments?.map((item, index) => (
                <tr
                  key={item?.booking_id}
                  className={`${
                    appointments?.length === index + 1 ? "" : "border-b"
                  } hover:bg-gray-50`}
                >
                  <td className="py-2 px-4">{index + 1}</td>
                  <td className="py-2 px-4">{item?.prvider_name || "-"}</td>
                  <td className="py-2 px-4">{item?.patient_name || "-"}</td>
                  <td className="py-2 px-4">{item?.date || "-"}</td>
                  <td className="py-2 px-4">{item?.time || "-"}</td>
                  <td className="py-2 px-4">{item?.fees || "-"}</td>
                  <td className="py-2 px-4">{item?.license_no || "-"}</td>
                  <td className="py-2 px-4">
                    <span
                      className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${
                        item?.status === "Confirmed" ||
                        item?.status === "Completed"
                          ? "bg-[#E6F8E9] text-[#00A651]"
                          : item?.status === "Cancelled"
                          ? "bg-[#FFF8EF] text-[#F04438]"
                          : "bg-[#FFF8EF] text-[#E0A256]"
                      }`}
                    >
                      {item?.status}
                    </span>
                  </td>
                  <td className="py-2 px-4">
                    <button
                      className="text-blue-600 hover:text-blue-800 underline"
                      onClick={() =>
                        navigate(
                          appointmentActiveTab === "Scheduled"
                            ? "/scheduledAppointmentDetail"
                            : appointmentActiveTab === "Completed"
                            ? "/completedAppointmentDetail"
                            : "/cancelledAppointmentDetail",
                          {
                            state: {
                              bookingId: item?.booking_id,
                              consumerId,
                              consumerName: item?.patient_name,
                              license_no: item?.license_no,
                            },
                          }
                        )
                      }
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="py-4 px-4 text-center text-gray-500">
                  No appointments found for {appointmentActiveTab}.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Appointment;
